import React, { useEffect, useLayoutEffect, useState } from 'react';
import { Entity } from '../../types';
import InfiniteScroll from 'react-infinite-scroller';
import { DocumentRow } from './DocumentRow';

type Props = {
  file: any;
  mainDocumentWrapper: React.RefObject<HTMLDivElement>;
  asideSectionMask: React.RefObject<HTMLDivElement>;
  entities: Entity[];
  entityRefs: any;
  filterItemsCount: number;
  setFilterItemsCount: (number: any) => any;
  documentScrollHeight: { start: number; end: number };
  setDocumentScrollHeight: (any: any) => any;
  setDetailEntity: (any: any) => any;
  onDocumentLoadSuccess: any;
  numPages: number;
};

export const DocumentSplitResult = ({
  file,
  mainDocumentWrapper,
  asideSectionMask,
  entities,
  entityRefs,
  documentScrollHeight,
  setDocumentScrollHeight,
  filterItemsCount,
  setFilterItemsCount,
  setDetailEntity,
  onDocumentLoadSuccess,
  numPages,
}: Props) => {
  const [expandedRow, setExpandedRow] = useState<number | null>(null);

  const calculateViewableSection = (scrollTop: number, scrollHeight: number, containerHeight: number) => {
    setDocumentScrollHeight({
      start: (scrollTop / scrollHeight) * 100,
      end: ((scrollTop + containerHeight) / scrollHeight) * 100,
    });
  };

  useEffect(() => {
    if (mainDocumentWrapper.current) {
      calculateViewableSection(0, mainDocumentWrapper.current.scrollHeight, mainDocumentWrapper.current.clientHeight);
    }
    //eslint-disable-next-line
  }, []);

  useLayoutEffect(() => {
    window.addEventListener('resize', () => {
      setTimeout(() => {
        onResize();
      }, 250);
    });
    return () => {
      window.removeEventListener('resize', onResize);
    };
    //eslint-disable-next-line
  }, []);

  const onResize = () => {
    if (mainDocumentWrapper.current) {
      const containerHeight = mainDocumentWrapper.current.clientHeight;
      const scrollHeight = mainDocumentWrapper.current.scrollHeight;
      const scrollTop = mainDocumentWrapper.current.scrollTop;
      calculateViewableSection(scrollTop, scrollHeight, containerHeight);
    }
  };

  const onScroll = (event: React.UIEvent<HTMLDivElement>) => {
    const containerHeight = event.currentTarget.clientHeight;
    const scrollHeight = event.currentTarget.scrollHeight;
    const scrollTop = event.currentTarget.scrollTop;

    calculateViewableSection(scrollTop, scrollHeight, containerHeight);
  };

  const fetchMore = () => {
    setFilterItemsCount((prev: number) => prev + 20);
  };

  return (
    <div
      ref={mainDocumentWrapper}
      onScroll={onScroll}
      style={{
        width: 'calc(100vw - 160px)',
        height: window.innerHeight - 58 + 'px',
        overflowY: 'auto',
        position: 'relative',
      }}>
      <InfiniteScroll
        style={{ height: '100%' }}
        pageStart={0}
        loadMore={fetchMore}
        hasMore={filterItemsCount < entities.length}
        useWindow={false}>
        {entities
          .filter((_, i) => i < filterItemsCount)
          .map((entity, i) => {
            return (
              <DocumentRow
                key={entity.id}
                entity={entity}
                entities={entities}
                i={i}
                entityRefs={entityRefs}
                file={file}
                numPages={numPages}
                setDetailEntity={setDetailEntity}
                expandedRow={expandedRow}
                setExpandedRow={setExpandedRow}
              />
            );
          })}
      </InfiniteScroll>
    </div>
  );
};
